const carouselItems = [
  {
    title: '暑期档热映',
    subtitle: '这个夏天不容错过的10部大片',
    desc: '从动作巨制到温情喜剧，桃子影院暑期专题为你精选今夏最热影片，4K蓝光画质带来影院级观影体验。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20scene%20with%20warm%20golden%20sunset%20light%20over%20a%20dark%20theater%20setting%2C%20film%20strip%20elements%2C%20abstract%20cinematic%20composition%2C%20luxurious%20warm%20tones%2C%20elegant%20minimal%20design%2C%20dramatic%20atmosphere&width=800&height=480&seq=carousel-01-summer&orientation=landscape',
    tag: '🔥 热映专题',
    tagClass: 'bg-accent-500 text-background-950',
  },
  {
    title: '经典重温',
    subtitle: 'IMDB Top 250 高分经典一网打尽',
    desc: '那些年感动无数观众的影史经典，桃子影院高清修复版本带你重温电影艺术的魅力与永恒。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20cinema%20atmosphere%20with%20warm%20sepia%20and%20golden%20accents%2C%20old%20film%20projector%20silhouette%2C%20nostalgic%20theater%20mood%2C%20rich%20textured%20dark%20background%2C%20elegant%20film%20noir%20aesthetic&width=800&height=480&seq=carousel-02-classic&orientation=landscape',
    tag: '⭐ 经典',
    tagClass: 'bg-primary-500 text-background-950',
  },
  {
    title: '追剧日历',
    subtitle: '每日更新，热播剧集永不掉队',
    desc: '桃子影院为您整理全网热播剧追更时间表，国产剧、韩剧、日剧、美剧同步更新，追剧党必备。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20streaming%20entertainment%20concept%20with%20warm%20peach%20and%20golden%20light%20gradients%2C%20dark%20elegant%20background%2C%20abstract%20play%20button%20and%20timeline%20elements%2C%20cozy%20viewing%20atmosphere&width=800&height=480&seq=carousel-03-calendar&orientation=landscape',
    tag: '📅 追剧',
    tagClass: 'bg-secondary-500 text-background-950',
  },
  {
    title: '4K蓝光专区',
    subtitle: '极致画质体验，每一帧都是壁纸',
    desc: '桃子影院4K蓝光专区汇集高码率影片资源，支持HDR与杜比音效，为您还原导演眼中的真实世界。',
    img: 'https://readdy.ai/api/search-image?query=Luxurious%20premium%20cinema%20experience%20visual%2C%20dark%20theater%20with%20soft%20golden%20and%20amber%20light%20beams%2C%20high%20contrast%20dramatic%20lighting%2C%20elegant%20minimal%20design%2C%20abstract%20lens%20and%20light%20elements&width=800&height=480&seq=carousel-04-4k&orientation=landscape',
    tag: '🎬 4K',
    tagClass: 'bg-accent-500 text-background-950',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-4">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            本周焦点影视专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            精心策划的专题内容，发现更多精彩影视
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-300/20 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[200px] md:h-[240px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/30 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${item.tagClass}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-100 mb-1 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm font-medium text-foreground-300 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}